<script setup lang="ts">
import { computed, onMounted, toRefs, watch } from "vue";
import { storeToRefs } from "pinia";
import { utc2local } from "@/utils";
import { useLogStore } from "@/stores/log";

const props = defineProps<{
  deviceId: string;
  orderId: string;
}>();

const logStore = useLogStore();
const { logData, searching, hasMore } = storeToRefs(logStore);
const { orderId, deviceId } = toRefs(props);
watch([orderId, deviceId], async () => {
  reset();
  await more();
});
const more = async () => {
  if (deviceId.value) {
    await logStore.anotherPage("device", deviceId.value);
  }
};
const filteredLog = computed(() => {
  return logData.value.filter((l) => l.orderId === props.orderId);
});
const reset = () => {
  logStore.reset();
  logStore.debug = true;
};
onMounted(async () => {
  reset();
  await more();
});
</script>

<template>
  <h2>Log</h2>
  <pn-table bordered="true">
    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th></th>
          <th>Action</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!logData.length">
          <td colspan="9">Empty</td>
        </tr>
        <tr
          v-for="log in filteredLog"
          :key="log.logDate"
          :class="[log.action, log.level]"
        >
          <td>{{ utc2local(log.logDate) }}</td>
          <td>{{ log.level }}</td>
          <td>{{ log.action }}</td>
          <td>{{ log.message }}</td>
        </tr>
      </tbody>
    </table>
  </pn-table>
  <pn-spinner size="2" v-show="searching" />
  <p v-show="hasMore">
    <pn-button v-on:click="more" small="true" appearance="light">
      Load more log entries
    </pn-button>
  </p>
</template>

<style lang="scss" scoped>
.error {
  background: #fee;
}

.note.info {
  background: #efe;
}

.info {
  background: #eef;
}
pn-table {
  max-width: 75%;
}
</style>
